<template>
  <div>
    <section>
      <div class="inner row5">
        <article class="loginInner">
          <h1>아이디 찾기</h1>
          <div class="aRow5">
            <p>
              고객님의 아이디 찾기가 완료되었습니다.
            </p>
          </div>

          <div class="inputBox">
            <label>아이디</label>
            <p>
              {{ $route.params.id }}
            </p>
          </div>
          <div class="inputBox">
            <label>가입일</label>
            <p>
              {{ $route.params.regDate }}
            </p>
          </div>
          <div class="inputBtnBox">
            <router-link to="/auth" class="firstAtagBtn" replace><span class="joinTxt nomargin"><strong>로 그 인</strong></span></router-link>
            <router-link to="/auth/pWResetAuth" replace><span class="joinTxt nomargin"><strong>비밀번호 찾기</strong></span></router-link>
          </div>
        </article>
      </div>
    </section> 
  </div>   
</template>

<script>
export default {
  name: 'IDForgotComplete'
}
</script>

<style scoped>
    .loginInner > h1 {
        color: #9E1915;
    }
</style>